import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder-analysis',
    description:
      'Analyze stakeholders by impact, influence, engagement, and support for an OCM project.',
    icon: 'tie',
    name: 'Stakeholder Analysis',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
